import { createSlice } from "@reduxjs/toolkit";

export const locationSlice = createSlice({ //reducers for both hours in global state
    name: 'location',
    initialState:{},
    reducers: {
        setLocation: (currentState, action) => {
            return action.payload
        },
        modifLocation: (currentState, action) => {
            let cleanLocation = {...currentState};
            //le paylod est un tableau d'attributs {champ,value} à modifier dans le state sejour
            let champList = [...action.payload];
            champList.forEach(attribut=>{
                cleanLocation[attribut.champ]=attribut.value;
            })
            return cleanLocation
        }
    }
});